module.exports = __webpack_public_path__ + "static/media/tweet2.6e5435e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tweets/tweet2.jpg
// module id = 459
// module chunks = 0